import "./CreditSolutions.module.css";
import Header from "@/reusable_sections/Header";
import OfficialVsOtherChannels from "./sections/OfficialVsOtherChannels";
import OurCompetencies from "./sections/OurCompetencies";
import Footer from "@/reusable_sections/Footer";
export default function CreditSolutionsPage() {
  return <div>
      <Header />
      <OfficialVsOtherChannels />
      <OurCompetencies />
      <Footer />
    </div>;
}